import request from '@/utils/request'

// POST /api/v1/admin/game/get_rtp 获取商户RTP
export function getMerchantRtp(data = {}) {
  return request({
    url: '/api/v1/admin/game/get_rtp',
    method: 'post',
    mock: false,
    data,
  })
}

// POST /api/v1/admin/game/set_rtp 设置商户RTP
export function setMerchantRtp(data) {
  return request({
    url: '/api/v1/admin/game/set_rtp',
    method: 'post',
    mock: false,
    data,
  })
}

